import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "@/data/content";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [loc]);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${scrolled ? "bg-midnight/80 backdrop-blur-xl border-b border-gold/10" : "bg-transparent"}`}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex flex-col leading-none">
          <span className="font-serif text-xl sm:text-2xl gold-text tracking-wide">Spunky Scissors</span>
          <span className="font-label text-[9px] text-white/60 mt-0.5">Salon &amp; Academy</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/ /g,'-')}`}
              className={`text-sm transition-colors hover:text-gold ${loc.pathname === n.to ? "text-gold" : "text-white/80"}`}>
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/academy" data-testid="nav-apply" className="btn-ghost text-sm">Apply Now</Link>
          <Link to="/book" data-testid="nav-book" className="btn-gold text-sm">Book Appointment</Link>
        </div>

        <button className="lg:hidden text-gold" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-midnight/95 backdrop-blur-xl border-t border-gold/10 px-5 py-6 flex flex-col gap-4" data-testid="mobile-menu">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className="text-white/85 text-lg" data-testid={`mobile-nav-${n.label.toLowerCase().replace(/ /g,'-')}`}>{n.label}</Link>
          ))}
          <Link to="/academy" className="btn-ghost text-center mt-2">Apply Now</Link>
          <Link to="/book" className="btn-gold text-center">Book Appointment</Link>
        </div>
      )}
    </header>
  );
};
